import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Link } from "../components/L";
import { useParams, useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import useSEO from "../hooks/useSEO";
import { translateDate } from "../i18n/dateTranslate";
import { RegistrationPopup } from "./MasterclassPage";
import FloatingRegisterButton from "../components/FloatingRegisterButton";

const COVER_IMG = "/api/files/local/masterclass-poster.png";

// tx-catalog-start
const speakerBios = {
  "Dr. Ardian Skendaj": {
    title: "Kirurg Oro-Maksilo-Facial",
    image: "/api/files/local/lektor-01.png",
    bio: [
      "Pedagog part-time ne Fakultetin e Mjekesise Dentare, UMT.",
      "Ka kryer studimet ne Fakultetin e Mjekesise Dentare ne vitin 2015, me rezultate te shkelqyera.",
      "Ka fituar burse studimi si student ekselent ne Granada, Spanje, gjate vitit akademik 2012-2013.",
      "Ka perfunduar 4 vite specializim afatgjate ne kirurgjine maksilofaciale, Spitali Francez, QSUT.",
      "Master universitar ne implantologjine zigomatike, pterigoide, transsinuzale dhe nazale, Universiteti UNICAMILLUS, Rome, Itali.",
      "Trajnim teoriko-praktik ne implantologjine monofazike, Tirane.",
      "Trajnues i certifikuar ne implantologji nga AIM Academy - ImplantSwiss, Zvicerr.",
      "Anetar i Shoqates Evropiane te Kirurgeve Kraniomaksilofaciale (EACMFS).",
      "Referues ne konferenca kombetare dhe nderkombetare.",
      "Autor dhe bashkautor ne disa artikuj shkencor."
    ]
  },
  "Dr. Ormir Bushati": {
    title: "Restorative & Implant Dentistry",
    image: "/api/files/local/lektor-02.png",
    bio: [
      "I diplomuar ne 2011 ne Fakultetin e Stomatologjise, Universiteti i Tiranes.",
      "Ka perfunduar Master te Nivelit te Dyte ne Protetike Dentare ne Universitetin e Sienes, Itali.",
      "Ka marre pjese ne kongrese dhe programe trajnimi ne mbare boten ne dentistrne restauruese, estetike dhe kirurgjine implantare.",
      "Fitues i disa cmimeve 'Best Case' dhe autor i disa publikimeve shkencore.",
      "Anetar i certifikuar dhe Country Chairperson per Shqiperine ne European Society of Cosmetic Dentistry (ESCD).",
      "Lektor kombeter dhe nderkombetar.",
      "Key Opinion Leader (KOL) per disa marka dentare.",
      "Trajner ne kurse hands-on ne dentistrne restauruese, protetike dhe kirurgjine implantare.",
      "Aktualisht lektor ne Western Balkans University dhe drejton nje praktike private dentare ne Shkoder."
    ]
  },
  "Dr. Alesio Bocari": {
    title: "Implantologist & KOL SHINING 3D Dental",
    image: "/api/files/local/lektor-03.png",
    bio: [
      "I diplomuar ne Dentistri nga Universiteti i Tiranes ne vitin 2009.",
      "Themelues dhe drejtues teknik i Delta Dent Academy.",
      "Ka ndjekur kurse te edukimit te vazhdueshem ne SHBA, Angli, Itali, Gjermani, France dhe Shqiperi.",
      "Anetar i Digital Dental Society (DDS).",
      "Anetar aktiv i Italian Academy of Osseointegration (IAO), European Association for Osseointegration (EAO) dhe International Piezosurgery Academy (IPA).",
      "Key Opinion Leader (KOL) per Ballkanin per SHINING 3D Dental.",
      "Anetar i MINEC Night Class of 2018.",
      "Autor i dizajnit per nje kit universal te osteotomise per implante.",
      "Lektor ne trajnime te organizuara nga MINEC ne Indi."
    ]
  },
  "Dr. Krenar Papraniku": {
    title: "Specialist ne Kirurgji Orale dhe Implantologji",
    image: "/api/files/local/lektor-04.png",
    bio: [
      "Specialist ne Kirurgji Orale dhe Implantologji me mbi 15 vjet pervoje te fokusuar ne implantet dentare.",
      "Qe nga viti 2013 ushtron si Kirurg Oral ne kliniken Prodent ne Tetove, ku mban edhe pozicionin e Drejtorit te Klinikes.",
      "Ka vendosur mbi 10,000 implante dentare, duke menaxhuar raste nga zevendesime individuale deri ne rehabilitime full jaw.",
      "Ka perfunduar specializimin ne Kirurgji Orale ne Universitetin 'Shen Kirili dhe Metodi' ne Shkup.",
      "Ka ndjekur trajnime te avancuara nderkombetare ne Gjermani dhe Europe ne implantologjine moderne, sinus lift, vendosje implantesh te menjehershme, menaxhim i indeve te buta dhe GBR.",
      "Anetar aktiv i European Association for Osseointegration.",
      "Ka ligjëruar mbi komplikimet ne implantologji.",
      "Ish-President i Simpoziumit Nderkombetar 'Dentist Day'."
    ]
  },
  "Dr. Guido Picciocchi": {
    title: "Prof. AC, University of Genoa",
    image: "/api/files/local/lektor-05.png",
    bio: [
      "I diplomuar nga Universiteti i Gjenoves, me te drejta publikimi.",
      "Praktikon ne kliniken e tij private MMR ne Gjenove.",
      "Specializohet ne protetiken dentare, te cilen e ka ligjëruar per shume vite.",
      "Ka zhvilluar aftesi te avancuara ne te gjitha fushat e implantologjise, perfshire kirurgjine e guiduar dhe rigjenerimin e kockes.",
      "Punon 100% nen mikroskop, duke zhvilluar konfigurime te avancuara fotografike per dentistrne.",
      "Profesor i Asociuar (Prof. AC) ne Universitetin e Gjenoves, ne Masterin e Nivelit II ne Implantologji.",
      "Key Opinion Leader (KOL) per ZEISS Microscopy.",
      "Anetar i MINEC (World Education for Megagen Implant).",
      "Bashkautor i librit 'Esthetic on Implants' (Edra).",
      "Autor i librit 'Lights in Dental Photography'.",
      "Lektor ne mbi 20 vende te botes."
    ]
  },
  "Dr. Achraf Souayah": {
    title: "DDS, Founder GDTC Tunisia",
    image: "/api/files/local/lektor-07.png",
    bio: [
      "Doktor i Kirurgjise Dentare, i diplomuar nga Fakulteti i Mjekesise Dentare ne Monastir, Tunizi.",
      "Themelues i GDTC (Global Dental Training Center) ne Tunizi.",
      "Anetar i DGOI (German Society of Oral Implantology) dhe SENAME.",
      "Ambassador per MINEC (MegaGen International Network of Education & Clinical Research).",
      "Clinical Expert Team Member per MegaGen America, specializuar ne Full Arch FP1 me qasje minimale invazive.",
      "Lektor kombetar dhe nderkombetar ne periodonci, implantologji, protetike dhe dentistri estetike.",
      "Provider i edukimit te vazhdueshem dhe instruktor i trajnimeve kirurgjikale live (AIE - Advanced Implant Educators, USA).",
      "Mban praktike private ne Tunizi dhe Dubai (EBA)."
    ]
  },
  "Dr. Eddy Marku": {
    title: "International Implant Specialist",
    image: "/api/files/local/lektor-06.png",
    bio: [
      "Ka filluar udhetimin e tij dentar ne Milano, duke perfunduar studimet ne vitin 2013.",
      "Mbi 13 vjet pervoje, i karakterizuar nga perkushtimi ndaj restaurimeve komplekse mbi implante, me interes te vecante ne konceptin FP1.",
      "Preciziteti dhe vemendja ndaj detajeve i kane fituar nje reputacion te shkelqyer ne Mbreterine e Bashkuar.",
      "Ka ligjëruar ne shume vende, duke frymezuar audiencat me njohurite e tij.",
      "Lektor ne Masterin Nderkombetar te Implantologjise Dentare ne UNICAMILLUS, Rome.",
      "Ka mësuar ne Universitetin e Buffalo, New York, SHBA.",
      "Specializohet ne rehabilitimin e plote te gojes me implante.",
      "Vazhdon te shtyje kufijet e asaj qe eshte e mundur ne teknologjine dentare."
    ]
  },
  "Dr. Edison Shimaj": {
    title: "Implantology & Aesthetic Dentistry",
    image: "/api/files/local/lektor-09.png",
    bio: [
      "Profesionist vizionar ne dentistri me ekspertize ne implantologji, ortodonci dhe dentistri estetike.",
      "I njohur per precizionin dhe perkushtimin ndaj inovacionit, kombinon teknologjine e avancuar me teknikat moderne.",
      "Perqafues i konceptit Slow Dentistry, siguron qe cdo procedure kryhet me kujdes maksimal.",
      "Zgjidhjet e tij ortodontike, perfshire aligners transparente te prodhuara nga kompania e tij, ridefinojne komfortin per pacientet.",
      "Ne dentistrne estetike, specializohet ne dizajnimin e buzeqeshjeve natyrale me teknika minimale invazive.",
      "Lider i respektuar dhe mentor, fuqizon ekipin e tij dhe frymezon koleget permes programeve te trajnimit."
    ]
  },
  "Dt. Hysen Dibra": {
    title: "THE LAB Team",
    image: "/api/files/local/lektor-10.png",
    bio: [
      "The Lab u themelua ne vitin 2008 si nje iniciative e Hysen Dibres dhe u zhvillua si pjese e vizionit te Perfect Dent Group per te rikonceptuar standardet e industrise dentare ne Shqiperi dhe ne rajon.",
      "Nga nje laborator i vogel, sot eshte shnderruar ne nje strukture moderne me 30 profesioniste te perkushtuar dhe kater departamente te specializuara: modelet, implantologjia, CAD/CAM dhe porcelani.",
      "Me fokus ne cilesi, inovacion dhe personalizim, The Lab ka pasur gjithmone te njejtin qellim: te ndertoje nje ure te forte bashkepunimi me mjeket dentiste, per te ofruar rezultate te jashtezakonshme per pacientet."
    ]
  },
  "Dt. Samed Isufaj": {
    title: "THE LAB Team",
    image: "/api/files/local/lektor-11.png",
    bio: [
      "Teknik dentar prane The Lab, i specializuar ne restaurime protetike mbi implante.",
      "Ekspertize ne workflow dixhital dhe prodhimin e strukturave me titan.",
      "Kontribues aktiv ne trajnimin e laboranteve te rinj."
    ]
  },
  "Dt. Klajdi Kapxhiu": {
    title: "THE LAB Team",
    image: "/api/files/local/lektor-12.png",
    bio: [
      "Teknik dentar prane The Lab, i specializuar ne CAD/CAM dhe restaurime estetike.",
      "Pervoje ne dizajnimin dixhital te protezave dhe strukturave full-arch.",
      "I fokusuar ne passive fit dhe precizionin e restaurimeve perfundimtare."
    ]
  }
};

const modules = [
  {
    id: 1, title: "Bazat e Implantologjise", date: "5-6 Qershor 2026",
    speakers: ["Dr. Ardian Skendaj", "Dr. Ormir Bushati"],
    day1: { date: "5 Qershor 2026", speaker: "Dr. Ardian Skendaj", topics: [
      "Historia e implanteve dentare", "Kategorite e implanteve dentare", "Biologjia e implantit dhe osteointegrimi",
      "Anatomia kirurgjikale e maksiles dhe mandibules", "Tipet e kockes dhe implikimet klinike",
      "Perzgjedhja e pacientit: indikacionet dhe faktoret e rrezikut", "Etika kirurgjikale - cfare NUK duhet bere",
      "Teknikat e incizionit, pergatitja e lembos dhe suturimi", "Instrumentariumi kirurgjikal dhe setet e implanteve"
    ], handson: ["Shpjegimi i kitit implantar", "Frezimi ne modele", "Suturimi"], cases: ["/api/files/local/case-m1d1-03.jpg", "/api/files/local/case-m1d1-01.jpg", "/api/files/local/case-m1d1-02.jpg", "/api/files/local/case-m1d1-04.jpg", "/api/files/local/case-m1d1-05.jpg", "/api/files/local/case-m1d1-06.jpg", "/api/files/local/case-m1d1-07.png", "/api/files/local/case-m1d1-08.jpg", "/api/files/local/case-m1d1-09.jpg", "/api/files/local/case-m1d2-02.jpg", "/api/files/local/case-m1d2-03.jpg", "/api/files/local/case-m1d2-04.jpg", "/api/files/local/case-m1d2-05.jpg", "/api/files/local/case-m1d2-01.jpg", "/api/files/local/case-m1d2-06.jpg"]},
    day2: { date: "6 Qershor 2026", speaker: "Dr. Ormir Bushati", topics: [
      "Faktoret qe percaktojne suksesin e nje implanti dentar", "Vleresimi i CBCT dhe analiza e tij klinike",
      "Pozicionimi tridimensional (3D) i implantit ne hapesire",
      "Kiti implantar dhe protokollet e frezimit sipas situatave te ndryshme klinike",
      "Implanti i menjehershem post-ekstraktiv kundrejt implantit te vonuar",
      "Planifikimi i trajtimit dhe opsionet protetike ne dentistrne implantare",
      "Vendosja e implantit me dore te lire kundrejt vendosjes se guiduar",
      "Situata klinike: implant direkt kundrejt nderhyrjeve pergatitore para implantimit"
    ], handson: ["Vleresim i CBCT", "Drilling hap pas hapi ne modele"], cases: ["/api/files/local/case-m1d2-ormir-01.jpg", "/api/files/local/case-m1d2-ormir-02.jpg", "/api/files/local/case-m1d2-ormir-03.jpg", "/api/files/local/case-m1d2-ormir-04.jpg", "/api/files/local/case-m1d2-ormir-05.jpg", "/api/files/local/case-m1d2-ormir-06.jpg", "/api/files/local/case-m1d2-ormir-07.jpg", "/api/files/local/case-m1d2-ormir-08.jpg", "/api/files/local/case-m1d2-ormir-09.jpg", "/api/files/local/case-m1d2-ormir-10.jpg", "/api/files/local/case-m1d2-ormir-11.jpg", "/api/files/local/case-m1d2-ormir-12.jpg", "/api/files/local/case-m1d2-ormir-13.jpg", "/api/files/local/case-m1d2-ormir-14.jpg", "/api/files/local/case-m1d2-ormir-15.png", "/api/files/local/case-m1d2-ormir-16.jpg", "/api/files/local/case-m1d2-ormir-17.png", "/api/files/local/case-m1d2-ormir-18.jpg", "/api/files/local/case-m1d2-ormir-19.jpg", "/api/files/local/case-m1d2-ormir-20.jpg", "/api/files/local/case-m1d2-ormir-21.jpg", "/api/files/local/case-m1d2-ormir-22.jpg"], groupSizes: [5, 5, 5, 2, 5]}
  },
  {
    id: 2, title: "Vendosja e Implanteve dhe Komplikacionet", date: "12-13 Qershor 2026",
    speakers: ["Dr. Alesio Bocari", "Dr. Krenar Papraniku"],
    day1: { date: "12 Qershor 2026", speaker: "Dr. Alesio Bocari", topics: [
      "Teknika flapless kundrejt teknikes me flap", "Pozicionimi implantar i drejtuar nga protetika",
      "Protokollet e vendosjes se implanteve post-ekstraktive", "Teknika Socket Shield",
      "Vleresimi i statusit te indeve te buta peri-implantare, rendesiae tyre dhe teknikat e ndryshme te permiresimit (CAF, CTG, FGG)",
      "Marrja e masave analoge dhe digjitale", "Hyrje ne workflow-n laboratorik"
    ], livedemo: "Vendosja e implantit post-ekstraktiv"},
    day2: { date: "13 Qershor 2026", speaker: "Dr. Krenar Papraniku", topics: [
      "Komplikimet biologjike: Peri-implantitis, probleme me indet e buta, infeksione",
      "Komplikimet protetike: Vida/abutment, fraktura, probleme te protezes mbi implante",
      "Komplikimet estetike: Humbja e papiles, recession, pozicionim jokorrekt 3D",
      "Komplikime serioze (te rralla): Hemorragji, demtim i nervit, aspirimi, fraktura te mandibules, zhvendosje ne sinus",
      "Diskutim i rasteve klinike (analize, vendimmarrje, strategji)"
    ]}
  },
  {
    id: 3, title: "Rigjenerimi i Drejtuar i Kockes (GBR)", date: "10-11 Korrik 2026",
    speakers: ["Dr. Guido Picciocchi"],
    day1: { date: "10 Korrik 2026", speaker: "Dr. Guido Picciocchi", topics: [
      "Fotografia klinike profesionale", "Pergatitja e rasteve klinike per dokumentim",
      "Rigjenerimi i drejtuar i kockes (GBR)", "Defektet kockore horizontale dhe vertikale",
      "Biomaterialet ne implantologji", "Graftet kockore: indikacionet dhe kufizimet",
      "Teknikat e stabilizimit te graftit kockor"
    ], livedemo: "Rigjenerimi i drejtuar i kockes te pacienti"},
    day2: { date: "11 Korrik 2026", speaker: "Dr. Guido Picciocchi", topics: [
      "Membranat ne rigjenerimin e drejtuar te kockes (mesh, lamina, PTFE)",
      "Menaxhimi i indeve te buta ne procedurat GBR", "GBR ne implantet post-ekstraktive",
      "Teknike Split Crest e kombinuar me GBR",
      "Komplikimet ne rigjenerimin e drejtuar te kockes dhe menaxhimi i tyre"
    ], handson: ["Rigjenerimi i drejtuar i kockes ne nofulla derri"]}
  },
  {
    id: 4, title: "Implantet Multiple, Kirurgjia e Sinusit dhe Planifikimi Strategjik", date: "4-5 Shtator 2026",
    speakers: ["Dr. Achraf Souayah"],
    day1: { date: "4 Shtator 2026", speaker: "Dr. Achraf Souayah", topics: [
      "Parimet biologjike dhe biomekanike te implanteve multiple", "Reagimi i kockes dhe shperndarja e ngarkesave",
      "Planifikimi biomekanik i implanteve", "Numri, diametri, gjatesia dhe pozicionimi tridimensional (3D)",
      "Strategjia e vendosjes sipas regjionit", "Regjioni posterior (forcat, cantilever, okluzioni)",
      "Regjioni anterior (menaxhimi i riskut estetik)", "Vendosja e implanteve ne densitete te ndryshme kockore (D1-D4)",
      "Partial Extraction Therapy (PET)", "Protokollet e ngarkes: ngarkesa e menjehershme",
      "Implante te shkurtra kundrejt augmentimit te sinusit", "Konceptet biomekanike ne rehabilitimet full-arch",
      "Vleresimi i riskut dhe parandalimi i komplikimeve", "Diskutim i rasteve klinike"
    ], cases: ["/api/files/local/case-m4d1-01.jpg", "/api/files/local/case-m4d1-02.jpg", "/api/files/local/case-m4d1-03.jpg", "/api/files/local/case-m4d1-04.jpg", "/api/files/local/case-m4d1-05.jpg", "/api/files/local/case-m4d1-06.jpg", "/api/files/local/case-m4d1-07.jpg", "/api/files/local/case-m4d1-08.jpg", "/api/files/local/case-m4d1-09.jpg", "/api/files/local/case-m4d1-10.jpg", "/api/files/local/case-m4d1-11.jpg", "/api/files/local/case-m4d1-12.jpg", "/api/files/local/case-m4d1-13.jpg", "/api/files/local/case-m4d1-14.jpg", "/api/files/local/case-m4d1-15.jpg", "/api/files/local/case-m4d1-16.jpg", "/api/files/local/case-m4d1-17.jpg", "/api/files/local/case-m4d1-18.jpg", "/api/files/local/case-m4d1-19.jpg", "/api/files/local/case-m4d1-20.jpg", "/api/files/local/case-m4d1-21.jpg", "/api/files/local/case-m4d1-22.jpg", "/api/files/local/case-m4d1-23.jpg", "/api/files/local/case-m4d1-24.jpg", "/api/files/local/case-m4d1-25.jpg", "/api/files/local/case-m4d1-26.jpg", "/api/files/local/case-m4d1-27.jpg", "/api/files/local/case-m4d1-28.jpg", "/api/files/local/case-m4d1-29.jpg", "/api/files/local/case-m4d1-30.jpg", "/api/files/local/case-m4d1-31.jpg"], groupSizes: [5, 5, 5, 5, 5, 5, 1]},
    day2: { date: "5 Shtator 2026", speaker: "Dr. Achraf Souayah", topics: [
      "Anatomia e sinusit maksilar dhe vleresimi radiologjik i avancuar me CBCT",
      "Perzgjedhja e rasteve: kur te kryhet graftim dhe kur te shmanget graftimi",
      "Ngritja krestale e sinusit: indikacionet, parashikueshmeria dhe kufizimet",
      "Ngritja e laterale e sinusit: protokoll kirurgjikal hap pas hapi",
      "Materialet rigjenerative: racionali biologjik dhe kriteret e perzgjedhjes",
      "Algoritmi i menaxhimit te komplikimeve (perforimi i membranes, gjakderdhja, infeksioni)",
      "Protokollet post-operative dhe ndjekja afatgjate"
    ], livedemo: "Ngritja laterale e sinusit (perzgjedhje edukative e rastit)", cases: ["/api/files/local/case-m4d2-01.jpg", "/api/files/local/case-m4d2-02.jpg", "/api/files/local/case-m4d2-03.jpg", "/api/files/local/case-m4d2-04.jpg", "/api/files/local/case-m4d2-05.jpg", "/api/files/local/case-m4d2-06.jpg", "/api/files/local/case-m4d2-07.jpg", "/api/files/local/case-m4d2-08.jpg", "/api/files/local/case-m4d2-09.jpg", "/api/files/local/case-m4d2-10.jpg", "/api/files/local/case-m4d2-11.jpg", "/api/files/local/case-m4d2-12.jpg", "/api/files/local/case-m4d2-13.jpg", "/api/files/local/case-m4d2-14.jpg", "/api/files/local/case-m4d2-15.jpg"], groupSizes: [5, 5, 5]}
  },
  {
    id: 5, title: "Epoka e Re e Rehabilitimit Full-Arch", date: "23-24 Tetor 2026",
    speakers: ["Dr. Eddy Marku", "Dr. Edison Shimaj"],
    day1: { date: "23 Tetor 2026", speaker: "Dr. Eddy Marku", topics: [
      "Perzgjedhja e rasteve ne rehabilitimet full-arch", "Konceptet FP1 vs FP3",
      "Marrja e regjistrimeve klinike (records)", "Kirurgjia e drejtuar & planifikimi protetikisht i orientuar",
      "Roli kyc i komponenteve implantologjike ne suksesin afatgjate",
      "Urat e menjehershme ne rehabilitimet full-arch", "Perzgjedhja e materialeve: cfare funksionon dhe cfare jo",
      "Epoka e re ne rehabilitimet full-arch", "Fotogrametria dhe precizioni absolut ne marrjen e masave",
      "Diskutim (pyetje-pergjigje)"
    ]},
    day2: { date: "24 Tetor 2026", speaker: "Dr. Edison Shimaj & Dr. Eddy Marku", topics: [
      "Analiza e rastit dhe strategjia kirurgjikale", "Diagnostikimi i pacientit dhe vleresimi klinik",
      "Analiza e CBCT dhe vleresimi i riskut anatomik", "Pergatitja kirurgjikale",
      "Vendosja e implanteve me guide te plote (live surgery)",
      "Vendosja e abutmenteve & pick-up protetik (workflow tradicional)",
      "Protokolli i fotogrametrise", "Marrja e skanimit dhe kuptimi i funksionimit te tij",
      "Adaptimi i provizorit te menjehershem", "Verifikimi i passive fit",
      "Rregullimet klinike dhe kontrolli funksional", "Vleresimi final, kontrolli i okluzionit & diskutim klinik"
    ], livedemo: "All-on-6 e guiduar ne pacient"}
  },
  {
    id: 6, title: "Workflow Protetik dhe Laboratorik", date: "25 Tetor 2026",
    speakers: ["Dt. Hysen Dibra", "Dt. Klajdi Kapxhiu", "Dt. Samed Isufaj"],
    day1: { date: "25 Tetor 2026", speaker: "Dt. Hysen Dibra", topics: [
      "Workflow laboratorik i orientuar protetikisht", "Projektimi dhe funksioni i restaurimeve provizore",
      "Kalimi nga restaurimi provizor ne restaurimin definitiv", "Passive fit dhe kontrolli i saktesise protetike",
      "Strukturat protetike te perforcuara me titan", "Defekte laboratorike te papranueshme"
    ]},
    day2: null
  }
];
// tx-catalog-end

const ModulePage = () => {
  const { tx, lang } = useLanguage();
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const modNum = parseInt(moduleId);
  const mod = modules.find(m => m.id === modNum);

  useSEO({
    title: mod ? `${tx("Moduli")} ${mod.id}: ${tx(mod.title)}` : tx("Modul Masterclass"),
    description: mod ? `Moduli ${mod.id} - ${mod.title}. ${mod.date}. Lektore: ${mod.speakers.join(", ")}. Masterclass i Implantologjise Moderne.` : "Modul i masterclass-it te implantologjise.",
    keywords: mod ? `moduli ${mod.id}, ${mod.title}, ${mod.speakers.join(", ")}, masterclass implantologji` : "masterclass implantologji",
    canonical: mod ? `https://aligners.academy/evente/masterclass/${mod.id}` : undefined,
  });

  const [showRegPopup, setShowRegPopup] = React.useState(false);
  const [lightbox, setLightbox] = React.useState(null);
  const [lbIndex, setLbIndex] = React.useState(0);
  const [lbImages, setLbImages] = React.useState([]);

  const openLightbox = (images, index) => {
    setLbImages(images);
    setLbIndex(index);
    setLightbox(true);
  };

  // Keyboard navigation
  React.useEffect(() => {
    if (!lightbox) return;
    const handleKey = (e) => {
      if (e.key === 'ArrowRight') setLbIndex(prev => (prev + 1) % lbImages.length);
      else if (e.key === 'ArrowLeft') setLbIndex(prev => (prev - 1 + lbImages.length) % lbImages.length);
      else if (e.key === 'Escape') setLightbox(null);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightbox, lbImages.length]);

  // Touch swipe
  const touchStart = React.useRef(null);
  const handleTouchStart = (e) => { touchStart.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStart.current === null) return;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setLbIndex(prev => (prev + 1) % lbImages.length);
      else setLbIndex(prev => (prev - 1 + lbImages.length) % lbImages.length);
    }
    touchStart.current = null;
  };

  if (!mod) return <div className="min-h-screen flex items-center justify-center"><p>{tx("Moduli nuk u gjet.")}</p></div>;

  const renderDay = (day, label, color) => {
    if (!day) return null;
    const speaker = speakerBios[day.speaker];
    return (
      <div className="mb-12">
        {/* Day Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="px-5 py-2 rounded-full text-sm font-bold text-white" style={{ background: color }}>{label}</span>
          <span className="text-sm text-[#828D9E]">{translateDate(day.date, lang)}</span>
        </div>

        {/* Two columns: Topics left, Speaker right */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8">
          {/* Left — Topics */}
          <div>
            <ol className="space-y-2.5 mb-6">
              {day.topics.map((t, i) => (
                <li key={i} className="flex items-start gap-3 text-[#4A5568]">
                  <span className="w-6 h-6 rounded flex items-center justify-center text-xs font-bold text-white flex-shrink-0 mt-0.5" style={{ background: color }}>{i + 1}</span>
                  <span className="text-sm leading-relaxed">{tx(t)}</span>
                </li>
              ))}
            </ol>

            {day.handson && (
              <div className="mb-5 p-4 rounded-xl bg-[#f8fafb] border border-slate-100">
                <h4 className="font-bold text-[#0A0D10] mb-2 text-sm"><i className="fas fa-hand-paper mr-2" style={{ color }}></i>Hands on:</h4>
                <ul className="space-y-1 ml-6">
                  {day.handson.map((h, i) => <li key={i} className="text-sm text-[#4A5568]">{tx(h)}</li>)}
                </ul>
              </div>
            )}

            {day.livedemo && (
              <div className="mb-5 p-4 rounded-xl border border-[#1CA3B0]/20 bg-[#1CA3B0]/5">
                <p className="font-bold text-[#0A0D10] text-sm"><i className="fas fa-video mr-2" style={{ color }}></i>Live Demo: <span className="font-normal text-[#4A5568]">{tx(day.livedemo)}</span></p>
              </div>
            )}

            <div>
              <h4 className="font-bold text-[#0A0D10] mb-3 text-sm"><i className="fas fa-folder-open mr-2" style={{ color }}></i>{tx("Raste Klinike")}</h4>
              {day.cases && day.cases.length > 0 ? (() => {
                const groups = [];
                const sizes = day.groupSizes || [3, 6, 6, 6, 6];
                let idx = 0;
                for (const size of sizes) {
                  if (idx >= day.cases.length) break;
                  groups.push(day.cases.slice(idx, idx + size));
                  idx += size;
                }
                if (idx < day.cases.length) groups.push(day.cases.slice(idx));
                return (<>{groups.map((group, gi) => {
                  const colsClass = group.length >= 5 ? "grid-cols-5" : group.length === 4 ? "grid-cols-4" : group.length === 2 ? "grid-cols-5" : group.length === 1 ? "grid-cols-5" : "grid-cols-3";
                  return (
                  <div key={gi} className={gi > 0 ? "mt-4 pt-4 border-t border-slate-100" : ""}>
                    <div className={`grid ${colsClass} gap-3`}>
                      {group.map((img, i) => {
                        const globalIdx = groups.slice(0, gi).reduce((s, g) => s + g.length, 0) + i;
                        return (
                          <div key={i} className="cursor-pointer group relative rounded-lg overflow-hidden" onClick={() => openLightbox(day.cases, globalIdx)}>
                            <img src={img} alt={`Rast klinik ${globalIdx + 1}`} className="w-full h-32 object-cover group-hover:scale-110 transition-transform duration-300" />
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                              <i className="fas fa-search-plus text-white opacity-0 group-hover:opacity-100 transition-opacity"></i>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  );
                })}</>);
              })() : (
                <div className="grid grid-cols-3 gap-3">
                  {[1, 2, 3].map(i => <div key={i} className="h-32 rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center text-slate-300"><i className="fas fa-image"></i></div>)}
                </div>
              )}
            </div>
          </div>

          {/* Right — Speaker Card */}
          {speaker && (
            <div className="rounded-2xl overflow-hidden border border-slate-100 bg-white h-fit sticky top-24">
              {speaker.image && (
                <div className="aspect-square overflow-hidden" style={{ background: '#0a0f1a' }}>
                  <img src={speaker.image} alt={day.speaker} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="p-5">
                <h4 className="font-bold text-[#0A0D10] text-base" style={{ fontFamily: "'Noto Sans', sans-serif" }}>{day.speaker}</h4>
                <p className="text-sm font-medium mb-4" style={{ color }}>{tx(speaker.title)}</p>
                <ul className="space-y-1.5">
                  {speaker.bio.map((line, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-[#4A5568] leading-relaxed">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0" style={{ background: color }}></span>
                      {tx(line)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div data-testid={`module-page-${modNum}`}>
      {/* Lightbox with arrows */}
      {lightbox && lbImages.length > 0 && createPortal(
        <div className="fixed inset-0 z-[300] flex items-center justify-center p-4" onClick={() => setLightbox(null)} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
          <div className="fixed inset-0 bg-black/85 backdrop-blur-sm" />
          <div className="relative z-[301] flex items-center gap-3 max-w-[90vw]" onClick={e => e.stopPropagation()}>
            {/* Left arrow */}
            {lbImages.length > 1 && (
              <button onClick={() => setLbIndex((lbIndex - 1 + lbImages.length) % lbImages.length)} className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-white/25 backdrop-blur flex items-center justify-center transition-all flex-shrink-0">
                <i className="fas fa-chevron-left text-white text-base"></i>
              </button>
            )}
            {/* Image */}
            <div className="relative">
              <button onClick={() => setLightbox(null)} className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-white text-[#0A0D10] flex items-center justify-center shadow-lg hover:bg-slate-100 z-10 text-sm font-bold">&times;</button>
              <img src={lbImages[lbIndex]} alt={`Rast klinik ${lbIndex + 1}`} className="max-w-full max-h-[80vh] rounded-xl shadow-2xl object-contain" />
              {lbImages.length > 1 && (
                <p className="text-center text-white/60 text-sm mt-3">{lbIndex + 1} / {lbImages.length}</p>
              )}
            </div>
            {/* Right arrow */}
            {lbImages.length > 1 && (
              <button onClick={() => setLbIndex((lbIndex + 1) % lbImages.length)} className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-white/25 backdrop-blur flex items-center justify-center transition-all flex-shrink-0">
                <i className="fas fa-chevron-right text-white text-base"></i>
              </button>
            )}
          </div>
        </div>,
        document.body
      )}
      {showRegPopup && createPortal(
        <RegistrationPopup onClose={() => setShowRegPopup(false)} source={`Moduli ${mod.id}: ${mod.title}`} />,
        document.body
      )}
      <FloatingRegisterButton onClick={() => setShowRegPopup(true)} testId="module-floating-register" />
      {/* Hero */}
      <section className="relative py-10 md:py-14 px-6" style={{ background: '#0a0f1a' }}>
        <div className="max-w-[1350px] mx-auto">
          <div className="flex items-center gap-2 text-white/60 text-sm mb-4">
            <Link to="/" className="hover:text-white">{tx("Kryefaqe")}</Link><span>/</span>
            <Link to="/evente" className="hover:text-white">{tx("Evente")}</Link><span>/</span>
            <Link to="/evente/masterclass" className="hover:text-white">Masterclass</Link><span>/</span>
            <span className="text-white">{tx("Moduli")} {mod.id}</span>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div>
              <div className="flex items-center gap-4 mb-4">
                <span className="w-14 h-14 rounded-xl flex items-center justify-center text-white font-bold text-xl" style={{ background: 'linear-gradient(130deg, #3CD4E1 0%, #003F72 100%)' }}>{mod.id}</span>
                <div>
                  <p className="text-[#3CD4E1] text-sm font-bold uppercase tracking-wider">{tx("Moduli")} {mod.id}</p>
                  <h1 className="text-white text-2xl md:text-3xl font-bold" style={{ fontFamily: "'Noto Sans', sans-serif" }}>{tx(mod.title)}</h1>
                </div>
              </div>
              <div className="flex flex-wrap gap-4 text-sm text-white/60 mt-4">
                <span><i className="fas fa-calendar-alt mr-2 text-[#3CD4E1]"></i>{translateDate(mod.date, lang)}</span>
                <span><i className="fas fa-users mr-2 text-[#3CD4E1]"></i>{mod.speakers.join(", ")}</span>
              </div>
            </div>
            {/* Speaker photos */}
            <div className="flex items-center -space-x-4">
              {mod.speakers.map((s, i) => {
                const sp = speakerBios[s];
                if (!sp?.image) return null;
                return (
                  <img key={i} src={sp.image} alt={s} className="w-24 h-24 lg:w-28 lg:h-28 rounded-2xl object-cover border-3 border-white/15" style={{ background: '#0a0f1a' }} />
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Content — Days stacked vertically */}
      <section className="py-16 px-6 md:px-12 max-w-[1350px] mx-auto">
        {renderDay(mod.day1, tx("Dita 1"), "#003F72")}
        {mod.day2 && <div className="border-t border-slate-200 pt-12">{renderDay(mod.day2, tx("Dita 2"), "#1CA3B0")}</div>}
      </section>

      {/* Navigation */}
      <section className="py-8 px-6 md:px-12 max-w-[1350px] mx-auto border-t border-slate-200">
        <div className="flex justify-between items-center">
          {modNum > 1 ? (
            <button onClick={() => navigate(`/evente/masterclass/${modNum - 1}`)} className="text-sm font-semibold flex items-center gap-2" style={{ color: '#1CA3B0' }}>
              <i className="fas fa-arrow-left"></i> {tx("Moduli")} {modNum - 1}
            </button>
          ) : <span />}
          <Link to="/evente/masterclass" className="text-sm text-[#828D9E] hover:text-[#0A0D10]">{tx("Te gjitha modulet")}</Link>
          {modNum < 6 ? (
            <button onClick={() => navigate(`/evente/masterclass/${modNum + 1}`)} className="text-sm font-semibold flex items-center gap-2" style={{ color: '#1CA3B0' }}>
              {tx("Moduli")} {modNum + 1} <i className="fas fa-arrow-right"></i>
            </button>
          ) : <span />}
        </div>
      </section>

      {/* CTA — Register for Masterclass */}
      <section className="relative py-12 overflow-hidden">
        <style>{`
          @keyframes ctaGradient { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
        `}</style>
        <div className="absolute inset-0" style={{ background: 'linear-gradient(270deg, rgb(0,63,114), rgb(4,63,70), rgb(0,63,114), rgb(4,63,70))', backgroundSize: '300% 300%', animation: 'ctaGradient 8s ease infinite' }} />
        <div className="relative z-10 max-w-[1350px] mx-auto px-6 text-center">
          <h2 className="text-xl font-bold mb-2 text-white" style={{ fontFamily: "'Noto Sans', sans-serif" }}>{tx("Regjistrohu ne Masterclass")}</h2>
          <p className="text-white/60 text-sm mb-6">Modern Implantology - From Fundamentals to Full-Arch Excellence</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button onClick={() => setShowRegPopup(true)} className="rounded-lg px-8 py-3 font-bold inline-flex items-center justify-center gap-2 bg-white text-[#003F72] hover:shadow-xl hover:-translate-y-0.5 transition-all" data-testid="module-register-btn">
              {tx("Regjistrohu Tani")} <i className="fas fa-arrow-right text-sm"></i>
            </button>
            <a href="https://wa.me/355696056794?text=Pershendetje%2C%20dua%20te%20di%20me%20shume%20per%20Masterclass-in" target="_blank" rel="noopener noreferrer" className="rounded-lg px-8 py-3 font-bold inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white hover:border-white hover:bg-white/10 transition-all">
              <i className="fab fa-whatsapp text-lg"></i> {tx("Me shume informacion")}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export { modules, speakerBios };
export default ModulePage;
